import { FormControl, FormHelperText, FormLabel, styled } from '@mui/material'
import Switch from '@mui/material/Switch'

const StyledFormLabel = styled(FormLabel)({
  color: '#616161',
  fontSize: 12,
  position: 'relative',
})

const InputSwitch = ({ disabled, error, label, onChange, required, value }: any) => (
  <FormControl error={Boolean(error)} required={required} disabled={disabled}>
    <StyledFormLabel>{label}</StyledFormLabel>
    <Switch checked={Boolean(value)} onChange={event => onChange(event.target.checked)} />
    <FormHelperText>{error}</FormHelperText>
  </FormControl>
)

export default InputSwitch
